import React from "react";

const SuperAdminDashboardPage = () => {
  return <div>Super Admin Dashboard</div>;
};

export default SuperAdminDashboardPage;
